import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { getUserInfo } from "@/lib/api/client-authentication";



type CertificationFormSubmit = {
	name: string;
	institution: string;
	credentialID?: string;
	dateIssued: string;
	endDate?: string;
	credentialUrl?: string;
};

type FormProps = {
	id: string;
	onUpdate: any;
	certificationDetails?: any;
};

export const CertificatesForm = ({
	id,
	onUpdate,
	certificationDetails,
}: FormProps) => {
	const validationSchema = Yup.object().shape({
		dateIssued: Yup.string().required("Date Issued is required"),
		institution: Yup.string().required("Institution is required"),
		name: Yup.string().required("Name is required"),
	});

	const {
		register,
		handleSubmit,
		reset,
		formState: { errors, isSubmitting },
	} = useForm<CertificationFormSubmit>({
		resolver: yupResolver(validationSchema),
		defaultValues: {
			name: certificationDetails?.certification?.name,
			institution: certificationDetails?.certification?.institution,
			credentialID: certificationDetails?.certification?.credentialID,
			dateIssued: certificationDetails?.certification?.dateIssued,
			endDate: certificationDetails?.certification?.endDate,
			credentialUrl: certificationDetails?.certification?.credentialUrl
		},
	});

	const resetForm = () => {
		reset();
	};

	const onSubmit = async (data: CertificationFormSubmit) => {
		const user = await getUserInfo();
		const certification = {
			name: data["name"],
			institution: data["institution"],
			credentialID: data["credentialID"],
			dateIssued: data["dateIssued"],
			endDate: data["endDate"],
			credentialUrl: data["credentialUrl"]
		};

		if (certificationDetails !== undefined) {
			onUpdate(
				id,
				{ index: certificationDetails?.index, certification },
				"edit"
			);
		} else {
			onUpdate(id, certification, "new");
		}
		resetForm();
	};

	return (
		<div className="profile-add">
			<div className="row">
				<div className="col-md-10 offset-sm-1">
					<h1 className="text-lg font-bold underline">Certification</h1>
					<br />
					<form>
						<div className="form-row mb-2">
							<div className="flex flex-col">
								<label className="text-base font-bold">Certification Name :</label>
								<input
									type="text"
									{...register("name")}
									className={`text-base border-black border  border-solid rounded-sm pl-1${errors.name ? "is-invalid" : ""
										}`}
									name="name"
								/>
								<div className="invalid-feedback">
									{errors.name?.message}
								</div>
							</div>
						</div>
						<div className="form-row mb-2">
							<div className="flex flex-col">
								<label className="text-base font-bold">Issuing Organization :</label>
								<input
									type="text"
									{...register("institution")}
									className={`text-base border-black border  border-solid rounded-sm pl-1${errors.institution ? "is-invalid" : ""
										}`}
									name="institution"
								/>
								<div className="invalid-feedback">
									{errors.institution?.message}
								</div>
							</div>
						</div>
						<div className="form-row mb-2">
							<div className="flex flex-col">
								<label className="text-base  font-bold">Credential ID :</label>
								<input
									type="text"
									{...register("credentialID")}
									className={`border-black border  border-solid rounded-sm pl-1 ${errors.credentialID ? "is-invalid" : ""
										}`}
									name="credentialID"
								/>
							</div>
						</div>
						<div className="form-row mb-2">
							<div className="flex flex-col">
								<label className="text-base  font-bold">Credential URL :</label>
								<input
									type="text"
									{...register("credentialUrl")}
									className={`border-black border  border-solid rounded-sm pl-1 ${errors.credentialUrl ? "is-invalid" : ""
										}`}
									name="credentialUrl"
								/>
							</div>
						</div>
						<div className="form-row mb-2">
							<div className="flex flex-col mb-2">
								<label className="text-base font-bold" htmlFor="date" >
									Date Issued
								</label>
								<div className="input-group date" id="datepicker">
									<input
										type="date"
										{...register("dateIssued")}
										className={`form-control ${errors.dateIssued ? "is-invalid" : ""
											}`}
										id="date"
									/>
									<div className="invalid-feedback">
										{errors.dateIssued?.message}
									</div>
								</div>
							</div>

							<div className="flex flex-col mb-2">
								<label className="text-base font-bold" htmlFor="date" >
									End Date
								</label>
								<div className="input-group date" id="datepicker">
									<input
										type="date"
										{...register("endDate")}
										className="form-control"
										id="date"
									/>
								</div>
							</div>
						</div>

						<div className="form-row">
							<div className="col-md-12 text-center">
								<button
									type="submit"
									onClick={handleSubmit(onSubmit)}
									className="btn btn-primary btn-save">
									Submit
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};
